module.exports = __webpack_public_path__ + "static/a11-1998809f989785f4479b37cb1cc0de5c.jpg";